import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GuideRunPouchContent } from '@libs/shared/interfaces/couch/models/guide-run';

@Injectable({
  providedIn: 'root',
})
@StoreConfig({
  name: 'guideRun',
  idKey: '_id',
})
export class GuideRunStore extends EntityStore<EntityState<GuideRunPouchContent, string>, GuideRunPouchContent> {
  constructor() {
    super();
  }
}
